import type { ResultsPersonaId } from "./personaIds";

export type PersonaMeta = {
	id: ResultsPersonaId;
	label: string;
	emoji: string;
	description: string;
	/** Shown in Slack select menus (≤75 chars). */
	exampleLine: string;
	/** Accent for generated channel avatar PNG. */
	avatarColor: string;
	/** Short label on avatar image. */
	avatarGlyph: string;
};

export const PERSONA_REGISTRY: PersonaMeta[] = [
	{
		id: "neutral",
		label: "Standard",
		emoji: ":bar_chart:",
		description: "Brief factual recap",
		exampleLine: "Plan A leads at 72%. Straight recap, no flair.",
		avatarColor: "#6B6B6B",
		avatarGlyph: "WI",
	},
	{
		id: "analyst",
		label: "The Analyst",
		emoji: ":bar_chart:",
		description: "Distribution and margins",
		exampleLine: "Margin vs #2: 14 pts. Bars and tie bands.",
		avatarColor: "#2E5AAC",
		avatarGlyph: "📊",
	},
	{
		id: "executive",
		label: "Executive brief",
		emoji: ":clipboard:",
		description: "Decision-ready bullets",
		exampleLine: "Decision: Lean Plan A. Turnout: 12 votes.",
		avatarColor: "#1E3A5F",
		avatarGlyph: "📋",
	},
	{
		id: "play_by_play",
		label: "The Announcer",
		emoji: ":studio_microphone:",
		description: "Play-by-play on the count",
		exampleLine: "At the wire — Plan A takes the tape at 100%!",
		avatarColor: "#C41E3A",
		avatarGlyph: "🎙",
	},
	{
		id: "pirate",
		label: "Captain Consensus",
		emoji: ":skull_crossbones:",
		description: "Nautical flair, same math",
		exampleLine: "Plan A claims the crow's nest. Chart's yer map.",
		avatarColor: "#0D5C63",
		avatarGlyph: "☠",
	},
	{
		id: "witty",
		label: "Casual desk",
		emoji: ":zap:",
		description: "Light humor",
		exampleLine: "Room picks Plan A — Borda pts spill the tea.",
		avatarColor: "#7B4BB7",
		avatarGlyph: "⚡",
	},
];

export function personaMeta(id: ResultsPersonaId): PersonaMeta {
	return PERSONA_REGISTRY.find((p) => p.id === id) ?? PERSONA_REGISTRY[0]!;
}
